import { Playground, Props } from 'docz';
import { Space, Tooltip } from '@madup-inc/mad-design';
import * as React from 'react';
export default {
  Playground,
  Props,
  Space,
  Tooltip,
  React
};